import React from "react";
import YukXatiAdd from "./YukXatiAdd";
import { Button, Modal } from "antd";

export default function YukxatiAdd_modal({ setIsModalOpen, isModalOpen }) {
  return (
    <Modal
      style={{ top: "10px" }}
      width={"100vw"}
      title="Yangi ЙУЛ ВАРАКАСИ"
      open={isModalOpen}
      //   loading={loadVagon}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
      }}
      footer={[]}
    >
      {isModalOpen ? <YukXatiAdd /> : null}
    </Modal>
  );
}
